import React from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { Table } from "antd";

const HierarchyResultDigitalMediaModal = ({
  isOpen,
  toggle,
  hierarchyListDataResult,
}) => {

  const columns = [
    {
      title: 'Program ID',
      dataIndex: 'id',
      key: 'id',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Program Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Result',
      dataIndex: 'result',
      key: 'result',
    },
  ];

  return (
    <Modal
      className="modal-media-hierarchy-list modal-lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <ModalHeader>
        <div>Following are the results of the hierarchy update:</div>
      </ModalHeader>

      <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
        <Table
          pagination={false}
          rowKey="id"
          columns={columns}
          dataSource={hierarchyListDataResult}
        />
      </ModalBody>
    </Modal>
  );
};

export default HierarchyResultDigitalMediaModal;
